import { useClock } from "../store/clock-store";
import React from "react";

interface ClockDisplayProps {
    variant?: 'time' | 'datetime'; // definuj varianty, které chceš podporovat
}

export const ClockDisplay: React.FC<ClockDisplayProps> = React.memo(({ variant = 'datetime' }) => {
    const now = useClock();

    return (
        <span>
            {variant === 'time'
                ? now.toLocaleTimeString('cs-CZ')
                : now.toLocaleString('cs-CZ')}
        </span>
    );
});
